// Constants for account limits and unlimited values
export const UNLIMITED_SEATS = 999;
export const UNLIMITED_CREDITS = 999999;
export const UNLIMITED_MONTE_CARLO = 999;
export const UNLIMITED_CHAT_HISTORY = 999;
export const UNLIMITED_ANALYSIS = 999;

// Common unlimited constant for display purposes
export const UNLIMITED_VALUE = 999;

// API Rate Limits
export const API_LIMITS = {
  QUANT_HOURLY: 100,
  QUANT_DAILY: 1000,
  PRO_HOURLY: 500,
  PRO_DAILY: 5000,
  ENTERPRISE_HOURLY: 999999,
  ENTERPRISE_DAILY: 999999
} as const;

// Analysis Limits
export const ANALYSIS_LIMITS = {
  QUANT: 5,
  PRO: UNLIMITED_ANALYSIS,
  ENTERPRISE: UNLIMITED_ANALYSIS
} as const;

// Chat History Limits
export const CHAT_HISTORY_LIMITS = {
  QUANT: 10,
  PRO: 50,
  ENTERPRISE: UNLIMITED_CHAT_HISTORY
} as const; 